// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2Xzjs","validationTips":"StatementDescriptor_validationTips__2QaAc"};